import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import logo from './images/logo.png';

export default function Footer() {
  const navigate = useNavigate(); 

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const navigateToPage = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-grid">
          

          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <div className="logo-icon">
                   <img src={logo} width={40} height={40} alt="Logo" />
                </div>
              </div>
              <div className="footer-logo-text">
                <h3>Dr. med. Lothar Boso</h3>
                <p>Ihre Gesundheit in besten Händen</p>
              </div>
            </div>
            <p className="footer-description">
              Moderne Medizin mit persönlicher Betreuung.
            </p>
          </div>
          <div className="footer-section">
            <h4>Navigation</h4>
            <div className="footer-links">
              <button onClick={() => scrollToSection('home')} className="footer-link">
                Start
              </button>
              <button onClick={() => scrollToSection('leistungen')} className="footer-link">
                Leistungen
              </button>
              <button onClick={() => scrollToSection('team')} className="footer-link">
                Team
              </button>
              <button onClick={() => navigateToPage('/gallery')} className="footer-link">
                Galerie
              </button>
              <button onClick={() => scrollToSection('kontakt')} className="footer-link">
                Kontakt
              </button>
            </div>
          </div>
          
      
          <div className="footer-section">
            <h4>Rechtliches</h4>
            <div className="footer-links">
              <button onClick={() => navigateToPage('/impressum')} className="footer-link">
                Impressum
              </button>
              <button onClick={() => navigateToPage('/datenschutz')} className="footer-link">
                Datenschutz
              </button>
            </div>
          </div>
        </div>
        

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; 2026 Praxis Dr. med. Lothar Boso Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
}